import { MerchantFieldsFragment } from '../../graphql/generated';
import { CashflowTransactionEntry } from './types';

export const buildMerchants = (
    transactionEntries: CashflowTransactionEntry[]
) => {
    const merchants: Record<string, MerchantFieldsFragment> = {};

    transactionEntries.forEach((transactionEntry) => {
        if (!transactionEntry.merchant) {
            return;
        }

        if (!merchants[transactionEntry.merchant.id]) {
            merchants[transactionEntry.merchant.id] = transactionEntry.merchant;
        }
    });

    return Object.values(merchants);
};
